export default {
  cache: 0,
  flag: "wait"
};
